import { redirect } from '@tanstack/react-router';

// Both auth tokens live in httpOnly cookies (invisible to JS). This flag
// carries no auth power on its own — it's just a client-side hint that a
// session cookie should exist, so route guards can decide synchronously
// without waiting on a network round trip.
const SESSION_FLAG_KEY = 'isLoggedIn';

export function markSession(): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(SESSION_FLAG_KEY, '1');
}

export function clearSession(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(SESSION_FLAG_KEY);
}

export function hasSessionFlag(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(SESSION_FLAG_KEY) === '1';
}

/** True only on the client when an admin session should exist. */
export function hasAuthToken(): boolean {
  return hasSessionFlag();
}

/**
 * Route `beforeLoad` guard: send unauthenticated users to /login.
 * Server-side render can't read the token, so the redirect is enforced
 * on the client; pair with a component-level guard for the SSR flash.
 */
export function requireAuth(): void {
  if (typeof window === 'undefined') return;
  if (!hasAuthToken()) {
    throw redirect({ to: '/login' });
  }
}
